"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var numberDropdownField_1 = require("./numberDropdownField");
var pages_1 = require("../../pages");
var EventTypeDropdown = /** @class */ (function (_super) {
    __extends(EventTypeDropdown, _super);
    function EventTypeDropdown(key, isRequired) {
        var _this = _super.call(this, key, 'Event Type', isRequired, [{ value: pages_1.EventTypes.Tradeshow, label: 'Tradeshow' }], 'Event type is required', pages_1.EventTypes.Tradeshow, _1.FieldType.DropDown) || this;
        _this.key = key;
        return _this;
    }
    EventTypeDropdown.prototype.setValue = function (value) {
        _super.prototype.setValue.call(this, value);
    };
    return EventTypeDropdown;
}(numberDropdownField_1.default));
exports.default = EventTypeDropdown;
